import React, { useEffect, useState } from "react";
import axios from "axios";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { API_URL, getHeader } from "../config";

const DEFAULT_IMAGE =
  "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/LVISGURGAON/public/Images/sld34.jpeg";
const NextArrow = ({ onClick }) => (
  <div className="slick-arrow slick-next customArrow" onClick={onClick}>
    ❯
  </div>
);

const PrevArrow = ({ onClick }) => (
  <div className="slick-arrow slick-prev customArrow" onClick={onClick}>
    ❮
  </div>
);

const MainSlider = () => {
  const [sliders, setSliders] = useState([]);

  useEffect(() => {
    const fetchSliders = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/api/slider/LVISGURGAON`,
          getHeader()
        );

        if (response.status === 200 && Array.isArray(response.data)) {
          setSliders(response.data);
          return;
        }

        setSliders([{ _id: "default-slide", attachment: DEFAULT_IMAGE }]);
      } catch (error) {
        setSliders([{ _id: "default-slide", attachment: DEFAULT_IMAGE }]);
      }
    };

    fetchSliders();
  }, []);

  var settings = {
    dots: true,
    infinite: true,
    fade: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    arrows: true,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };
  return (
    <>
      <div className="slider_blk">
        <Slider {...settings}>
          {sliders.length === 0 ? (
            <div>
              <img
                src={DEFAULT_IMAGE}
                alt="Lotus Valley Gurgaon"
                className="img-fluid"
              />
            </div>
          ) : (
            sliders.map((slider, index) => {
              const imageSource =
                slider?.attachment?.startsWith("http")
                  ? slider.attachment
                  : `https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/${slider?.attachment}`;

              return (
                <div key={slider?._id || index}>
                  <img
                    src={imageSource || DEFAULT_IMAGE}
                    alt={slider?.title || "Lotus Valley Gurgaon"}
                    className="img-fluid"
                  />
                </div>
              );
            })
          )}
        </Slider>
      </div>
    </>
  );
};
export default MainSlider;
